import axios from "axios";
import { Fragment, useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import "../Board/NoticeDetail.scss";
import "../CustomerBoard/CustomerqaDetail.scss";
import DOMPurify from "dompurify";
import "./ReviewCompletionStatus.scss";

export default function ReviewCompletionStatusDetail() {
  const { state } = useLocation();
  const [prevData, setPrevData] = useState([]);
  const [addition, setAddition] = useState([]);
  const [certificateUploaded, setCertificateUploaded] = useState([]);

  const getPrevData = async () => {
    try {
      const response = await axios.get(`/api/apply-proc-result/${state}`);
      for (
        let i = 0;
        i < response.data?.applyProcess?.applyFormValues?.length;
        i++
      ) {
        response.data.applyProcess.applyFormValues[i].subData = [];

        for (
          let j = 1;
          j < response.data?.applyProcess?.applyFormValues?.length;
          j++
        ) {
          if (
            response.data.applyProcess.applyFormValues[i].itemName ===
            response.data.applyProcess.applyFormValues[j].parentItemName
          ) {
            response.data.applyProcess.applyFormValues[i].subData.push(
              response.data.applyProcess.applyFormValues[j].description
            );
            response.data.applyProcess.applyFormValues[j].subInvisible = 1;
          }
        }
      }
      let filteredData = response.data;
      let filteredApplyForms = filteredData.applyProcess.applyFormValues.filter(
        (el) => el.subInvisible !== 1
      );
      filteredData.applyProcess.applyFormValues = filteredApplyForms;
      setPrevData(filteredData);

      const response3 = await axios.get(
        `/api/apply-proc/${response.data.applyProcessId}`
      );
      setAddition(response3.data.addition);
      setCertificateUploaded(response3.data.certificateUploaded);
    } catch (err) {
      console.log(err);
    }
  };
  useEffect(() => {
    window.scrollTo({
      top: 0,
    });
    getPrevData();
  }, [state]);
  const CommonTd = ({ title, context }) => {
    return (
      <>
        <tr style={{ height: "45px", wordBreak: "keep-all" }}>
          <td
            width="30%"
            style={{
              backgroundColor: "black",
              color: "white",
              border: "1px solid black",
              borderCollapse: "collapse",
            }}
          >
            <b>{title}</b>
          </td>

          <td
            style={{
              border: "1px solid black",
              borderCollapse: "collapse",
            }}
          >
            {context}
          </td>
        </tr>
      </>
    );
  };
  return (
    <>
      <div className="help_prev">
        <h1>인증정보</h1>

        <div className="help_prev_list_wrap">
          <ul className="help_prev_list">
            <table
              width="100%"
              style={{
                textAlign: "center",
                backgroundColor: "white",
                border: "1px solid black",
                borderCollapse: "collapse",
              }}
            >
              <tbody>
                <tr style={{ height: "55px", wordBreak: "keep-all" }}>
                  <td
                    style={{
                      backgroundColor: "#616B73",
                      color: "white",
                      border: "1px solid black",
                      borderCollapse: "collapse",
                    }}
                    colSpan={2}
                  >
                    {prevData.applyProcess?.applicant.companyName}
                  </td>
                </tr>
                {/* <CommonTd
                title="회사명"
                context={prevData.applyProcess?.applicant.companyName}
              /> */}
                <CommonTd
                  title="대표자"
                  context={prevData.applyProcess?.applicant.ceoName}
                />
                <CommonTd
                  title="인증번호"
                  context={prevData.qualificationNum}
                />
                <CommonTd
                  title="사업자번호"
                  context={prevData.applyProcess?.applicant.companyRegNum}
                />
                {prevData.applyProcess?.prdName && (
                  <CommonTd
                    title="제품명"
                    context={prevData.applyProcess?.prdName}
                  />
                )}
                {prevData.applyProcess?.modelName && (
                  <CommonTd
                    title="모델명"
                    context={prevData.applyProcess?.modelName}
                  />
                )}
                {addition?.length > 0
                  ? addition.map((e, idx) => {
                      return (
                        <Fragment key={idx}>
                          {e.prdName && (
                            <CommonTd title="추가제품명" context={e.prdName} />
                          )}
                          {e.modelName && (
                            <CommonTd
                              title="추가모델명"
                              context={e.modelName}
                            />
                          )}
                        </Fragment>
                      );
                    })
                  : null}

                <CommonTd
                  title="최초인증일자"
                  context={prevData.qualificationDate
                    ?.substring(0, 11)
                    .replace(/-/g, ".")
                    .replace(/-/g, ".")}
                />
                <CommonTd
                  title="인증유효기간"
                  context={
                    <>
                      {" "}
                      {prevData.qualificationDate
                        ?.substring(0, 11)
                        .replace(/-/g, ".")
                        .replace(/-/g, ".")}
                      ~
                      {prevData.expiredDate
                        ?.substring(0, 11)
                        .replace(/-/g, ".")
                        .replace(/-/g, ".")}{" "}
                    </>
                  }
                />
                <tr style={{ height: "45px", wordBreak: "keep-all" }}>
                  <td
                    style={{
                      backgroundColor: "black",
                      color: "white",
                      border: "1px solid black",
                      borderCollapse: "collapse",
                    }}
                  >
                    <b>인증서다운로드</b>
                  </td>
                  {addition?.length > 0 ? (
                    <td>
                      {certificateUploaded ? (
                        <a
                          href={`/api/apply-proc/${
                            addition[addition.length - 1].id
                          }/completeCertDoc`}
                          style={{
                            cursor: "pointer",
                            wordBreak: "keep-all",
                            color: "#2883f3",
                            textAlign: "center",
                          }}
                          download
                        >
                          인증서 다운로드
                        </a>
                      ) : (
                        <span style={{ color: "#999" }}>인증서 다운로드</span>
                      )}
                    </td>
                  ) : (
                    <td>
                      {certificateUploaded ? (
                        <a
                          href={`/api/apply-proc/${prevData?.applyProcessId}/completeCertDoc`}
                          style={{
                            cursor: "pointer",
                            wordBreak: "keep-all",
                            color: "#2883f3",
                            textAlign: "center",
                          }}
                          download
                        >
                          인증서 다운로드
                        </a>
                      ) : (
                        <span style={{ color: "#999" }}>인증서 다운로드</span>
                      )}
                    </td>
                  )}
                </tr>
                {prevData.state === 8 || prevData.state === 13 ? (
                  <CommonTd
                    title="비고"
                    context={
                      prevData.state === 1 ? (
                        <span> 신청완료</span>
                      ) : prevData.state === 2 ? (
                        <span>정기심사완료</span>
                      ) : prevData.state === 3 ? (
                        <span>재평가완료</span>
                      ) : prevData.state === 4 ? (
                        <span> 추가완료</span>
                      ) : prevData.state === 5 ? (
                        <span> 변경완료</span>
                      ) : prevData.state === 6 ? (
                        <span> 재발급완료</span>
                      ) : prevData.state === 8 ? (
                        <span style={{ color: "red" }}>
                          {" "}
                          취소(
                          {prevData?.updateAt
                            .substring(0, 11)
                            .replace(/-/g, ".")
                            .replace(/-/g, ".")}
                          )
                        </span>
                      ) : prevData.state === 13 ? (
                        <span style={{ color: "red" }}>
                          {" "}
                          중지(~
                          {prevData?.limitDate
                            .substring(0, 11)
                            .replace(/-/g, ".")
                            .replace(/-/g, ".")}
                          )
                        </span>
                      ) : null
                    }
                  />
                ) : null}
              </tbody>
            </table>
          </ul>
          <ul className="help_prev_list">
            <table
              width="100%"
              style={{
                textAlign: "center",
                backgroundColor: "white",
                border: "1px solid black",
                borderCollapse: "collapse",
              }}
            >
              {prevData.applyProcess?.applyFormValues?.map((e, idx) => {
                const safeDescription = DOMPurify.sanitize(e.description);

                return (
                  <Fragment key={idx}>
                    <tbody>
                      <tr
                        key={e.id}
                        style={{ height: "45px", wordBreak: "keep-all" }}
                      >
                        <td
                          width="30%"
                          style={{
                            flex: "0.1",
                            backgroundColor: "black",
                            color: "white",
                            border: "1px solid black",
                            borderCollapse: "collapse",
                          }}
                        >
                          <b>{e.entryName}</b>
                        </td>

                        <td
                          style={{
                            flex: "0.1",
                            border: "1px solid black",
                            borderCollapse: "collapse",
                            padding: "14px 10px",
                            lineHeight: "1.2",
                          }}
                        >
                          <span dangerouslySetInnerHTML={{ __html: safeDescription }} />
                          {e.subData.length > 0 && <> / {e.subData.slice()}</>}
                        </td>
                      </tr>
                    </tbody>
                  </Fragment>
                );
              })}
            </table>
          </ul>
        </div>
      </div>
    </>
  );
}
